import Vue from 'vue'
import VueRouter from 'vue-router'
//import store from '@/store'
Vue.use(VueRouter)

const routes = [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/home')
  },
  {
    path: '/huoyunxx',
    name: 'huoyunxx',
    component: () => import('@/views/huoyunxx')
  },
  {
    path: '/cheyuanxx',
    name: 'cheyuanxx',
    component: () => import('@/views/cheyuanxx')
  },
  {
    path: '/chelgz',
    name: 'cheyuanxx',
    component: () => import('@/views/chelgz')
  },
  {
    path: '/huowgz',
    name: 'huowgz',
    component: () => import('@/views/huowgz')
  },
  // {
  //   path: '/appdownload',
  //   name: 'appdownload',
  //   component: () => import('@/views/appdownload')
  // },
  {
    path: '/contactus',
    name: 'contactus',
    component: () => import('@/views/contactus')
  },
  {
    path: '/aboutus',
    name: 'aboutus',
    component: () => import('@/views/aboutus')
  },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news')
  },
  {
    path: '/notice',
    name: 'notice',
    component: () => import('@/views/notice')
  },
  {
    path: '/details',
    name: 'details',
    component: () => import('@/views/details')
  },
  {
    path: '/tongzhixx',
    name: 'tongzhixx',
    component: () => import('@/views/tongzhixx')
  },
  {
    path: '/tongzhidetails',
    name: 'tongzhidetails',
    component: () => import('@/views/tongzhidetails')
  }
  ,
  {
    path:'*',
    redirect:'/home'
    //component: () => import('@/components/404')
  }
]

const router = new VueRouter({
  //mode: 'history',
  base:process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if(savedPosition){
      return savedPosition
    }
    return {x:0,y:0}
  }
})

// router.beforeEach((to,from,next) => {
//    store.commit('cleanerToken');
//   if(sessionStorage.login){
//     next()
//   }else{
//     console.log(to)
//     if(/login|register/.test(to.path)){
//       next()
//     }else{
//       next('/login')
//     }
//   }
// })

export default router
